module.exports = __webpack_public_path__ + "f4f95164c1c91095ffe3424551ec2075.png";